__turbopack_context__.v({
  "active": "Indicator-module-scss-module__cJi8aG__active",
  "circle": "Indicator-module-scss-module__cJi8aG__circle",
  "text": "Indicator-module-scss-module__cJi8aG__text",
  "wrapper": "Indicator-module-scss-module__cJi8aG__wrapper",
});
